module.exports = __webpack_public_path__ + "img/ads-template.1ab49356.svg";